export const initState = {
    isReady: false
}

export default function handler(state = initState, actions) {
    if (actions.type == "app"){
        return { ...actions.payload };
    }
    return state;
}